// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  background: transparent;
  border-radius: var(--radius-default);
  height: 22px;
  padding: 0 8px;
  margin-right: 5px;
  border: 1px solid #785526;
}
.chip p {
  font-family: AppFontSemiBold;
  font-size: 12px;
  line-height: 14.2px;
  text-transform: uppercase;
}
.chip .table {
  color: #785526;
  margin-right: 3px;
}
.chip .number {
  color: #785526;
}
.chip ion-icon {
  margin-left: 5px;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/chip-table/chip-table.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,oCAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EAEA,yBAAA;AAAD;AACC;EACC,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AACF;AAEC;EACC,cAAA;EACA,iBAAA;AAAF;AAEC;EACC,cAAA;AAAF;AAEC;EACC,gBAAA;EACA,YAAA;AAAF","sourcesContent":[".chip {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tflex-wrap: nowrap;\n\tbackground: transparent;\n\tborder-radius: var(--radius-default);\n\theight: 22px;\n\tpadding: 0 8px;\n\tmargin-right: 5px;\n\n\tborder: 1px solid #785526;\n\tp {\n\t\tfont-family: AppFontSemiBold;\n\t\tfont-size: 12px;\n\t\tline-height: 14.2px;\n\t\ttext-transform: uppercase;\n\t\t\n\t}\n\t.table {\n\t\tcolor: #785526;\n\t\tmargin-right: 3px;\n\t}\n\t.number {\n\t\tcolor: #785526;\n\t}\n\tion-icon {\n\t\tmargin-left: 5px;\n\t\tcolor: white;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
